module.exports = __webpack_public_path__ + "assets/lit-element.a9ea682d.svg";